<script>
	import CustomButton from "../../../../components/CustomButton/CustomButton.svelte";
	import CustomDatePicker from "../../../../components/CustomDatePicker/CustomDatePicker.svelte";
	import CustomSearch from "../../../../components/CustomSearch/CustomSearch.svelte";
	import LimitSize from "../../../../components/SizeSelect/limitSize.svelte";
	import { Col, Row } from "@sveltestrap/sveltestrap";
	import { initPage } from "src/store/store";
	import CustomInput from "../../../../components/CustomInput/CustomInput.svelte";
	import { debounce } from "lodash";
	import { navigate } from "svelte-routing";
	import {
		caseClosingReasonOptions,
		caseOriginDropdownCheckBoxOptions,
	} from "src/utils/options";
	import LastUpdatedDateTime from "src/components/LastUpdatedDateTime/LastUpdatedDateTime.svelte";
	import DropdownCheckbox from "src/components/DropdownCheckbox/DropdownCheckbox.svelte";
	import { getOrDefault, updateCheckboxOptions } from "src/utils/misc";

	export let handleVehicleSearch = () => {};
	export let changeSearchParams = () => {};
	export let params = {};

	let caseOriginIsOpen = false;

	$: caseOriginCheckboxOptions = updateCheckboxOptions(
		caseOriginDropdownCheckBoxOptions,
		params.caseOrigin
	);

	$: plateNo = getOrDefault(params.plateNo, "");
	$: vehicleId = getOrDefault(params.vehicleId, "");
	$: investigator = getOrDefault(params.investigator, "");
	$: rejectedAt = getOrDefault(params.rejectedAt, "");
	$: rejectedReason = getOrDefault(params.rejectedReason, "");

	const debouncedInput = debounce((e) => handleChange(e), 1000);

	function handleChange(value) {
		changeSearchParams({ ...value, pageNumber: 1, page: 1 });
		initPage.set(1);
	}

	function resetFilter() {
		initPage.set(1);
		navigate("/issues/case-management?tab=Closed");
		changeSearchParams("");
	}

	function toggleCaseOrigin() {
		caseOriginIsOpen = !caseOriginIsOpen;
	}
</script>

<Row style="padding-right: 0">
	<Col xs={12}>
		<Row>
			<Col xs={10}>
				<Row class="gx-2">
					<Col>
						<CustomSearch
							loadOptions={handleVehicleSearch}
							id={`plateNo`}
							type="text"
							placeholder={`Vehicle No`}
							bind:value={plateNo}
							containerClasses={`search-icon`}
							onSelect={(e) => {
								plateNo = e.detail.label;
								vehicleId = e.detail.value;
								handleChange({
									vehicleId,
									plateNo,
								});
							}}
							handleClear={() => {
								plateNo = "";
								vehicleId = "";
								handleChange({
									vehicleId,
									plateNo,
								});
							}}
						/>
					</Col>
					<Col>
						<CustomDatePicker
							onChange={(e) => {
								handleChange({
									rejectedAt: e.detail,
								});
							}}
							value={rejectedAt}
							name="rejectedAt"
							isRange={false}
							placeholder={"Case Closed On"}
						/>
					</Col>
					<Col>
						<CustomInput
							placeholder="Investigator"
							search
							bind:value={investigator}
							onInput={(e) =>
								debouncedInput({
									[e.target.name]: e.target.value,
								})}
							name="investigator"
						/>
					</Col>

					<Col>
						<CustomSearch
							items={caseClosingReasonOptions}
							isSearchable={false}
							placeholder="All Reasons"
							id="rejectedReason"
							bind:value={rejectedReason}
							onSelect={(e) => {
								if (e.detail.value !== params.rejectedReason) {
									rejectedReason = e.detail.value;
									handleChange({
										rejectedReason,
									});
								}
							}}
							handleClear={() => {
								rejectedReason = "";
								handleChange({
									rejectedReason,
								});
							}}
						/>
					</Col>
				</Row>
			</Col>
		</Row>
		<Row class="mb-3">
			<Col xs={9}>
				<Row class="gx-2">
					<Col xs={3}>
						<DropdownCheckbox
							categoryName="All Case Origin"
							options={caseOriginCheckboxOptions}
							id="caseOrigin"
							isOpen={caseOriginIsOpen}
							toggle={toggleCaseOrigin}
							refetch={handleChange}
						/>
					</Col>

					<Col class="d-flex align-items-center">
						<CustomButton
							style="border-color: transparent; font-weight: bold;"
							buttonText="Clear filters"
							on:click={resetFilter}
							color="secondary"
						/>
					</Col>
				</Row>
			</Col>
			<Col xs={3} style="position:relative; padding-right:0">
				<LimitSize />

				<div class="d-flex justify-content-end">
					<LastUpdatedDateTime />
				</div>
			</Col>
		</Row>
	</Col>
</Row>
